import { ActionTree } from "vuex";
import { State } from "./state";

import axios from "@/utils/axios";

import { IS_LOADING, SET_SUCCESS, SET_DATA_LIST, SET_ERROR, SET_YT_LINK } from "@/store/UnterrichtDashboard/types";
import { Vue } from "vue-property-decorator";
import i18n from "@/i18n";

const URL = "/unterricht-dashboard";

export const findAllWidgets = async (store: any): Promise<any> => {
  store.commit(IS_LOADING, true);

  return await axios
    .get(URL)
    .then(({ data }) => {
      store.commit(SET_DATA_LIST, data);
      store.commit(SET_SUCCESS, true);
    })
    .catch(({ error }) => {
      store.commit(SET_SUCCESS, false);
      store.commit(SET_ERROR, error);
    })
    .finally(() => store.commit(IS_LOADING, false));
};

export const updateWidgets = async (store: any, data: any): Promise<any> => {
  store.commit(IS_LOADING, true);

  return await axios
    .put(URL, data)
    .then(({ data }) => {
      store.commit(SET_SUCCESS, true);
      Vue.toasted.success(String(i18n.t("messages.operation_successful")));
    })
    .catch(({ error }) => {
      store.commit(SET_ERROR, error);
      Vue.toasted.error(String(i18n.t("messages.operation_error")));
    })
    .finally(() => store.commit(IS_LOADING, false));
};

export const uploadWidgetImg = async (store: any, data: any): Promise<any> => {
  store.commit(IS_LOADING, true);

  return await axios
    .post(`${URL}/img?widgetId=${data.id}`, data.file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(() => {
      store.commit(SET_SUCCESS, true);
      Vue.toasted.success(String(i18n.t("messages.operation_successful")));
    })
    .catch((err) => {
      const errorMessage = err?.response?.data?.message || "Das Hochladen des Bildes ist fehlgeschlagen";
      store.commit(SET_ERROR, errorMessage);
      Vue.toasted.error(errorMessage);
    })
    .finally(() => store.commit(IS_LOADING, false));
};

export const findYtLink = async (store: any): Promise<any> => {
  store.commit(IS_LOADING, true);

  return await axios
    .get(URL + "/youtube-link")
    .then(({ data }) => {
      store.commit(SET_YT_LINK, data);
      store.commit(SET_SUCCESS, true);
    })
    .catch(({ error }) => {
      store.commit(SET_SUCCESS, false);
      store.commit(SET_ERROR, error);
    })
    .finally(() => store.commit(IS_LOADING, false));
};

export default <ActionTree<State, any>>{
  findAllWidgets,
  updateWidgets,
  uploadWidgetImg,
  findYtLink,
};
